import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { textColor, THEME_SILVER } from '../../../styles/basics/colors';
import { useTranslation } from 'react-i18next';

const StText = styled.span<{ bold?: boolean; multiLine?: boolean }>`
    font-size: 15px;
    font-weight: ${props => (props.bold ? 'bold' : 'normal')};
    white-space: ${props => (props.multiLine ? 'pre-line' : 'initial')};
`;

StText.displayName = 'LCFormFieldValueText__StText';

const StPlaceholder = styled.span`
    font-size: 15px;
    ${textColor(THEME_SILVER)};
`;

StPlaceholder.displayName = 'LCFormFieldValueText__StPlaceholder';

interface Props {
    text?: string | number;
    bold?: boolean;
    multiLine?: boolean;
    placeholder?: string | ReactElement;
}

export const LCFormFieldValueText = (props: Props) => {
    const { t } = useTranslation();
    const { placeholder = t('yourLocalContent.yourTitles.none') } = props;
    return props.text ? (
        <StText bold={props.bold} multiLine={props.multiLine}>
            {props.text}
        </StText>
    ) : (
        <StPlaceholder>{placeholder}</StPlaceholder>
    );
};
